module.exports = __webpack_public_path__ + "img/pic_333832.4bcd81ae.jpg";